import { FC } from "react"
import './scenariokpi.css'
import { IoMdArrowDropdown, IoMdArrowDropup, IoMdArrowUp } from "react-icons/io"
import { isNanParseFloatTreatment, numberFormatter } from "../../../utils/helperFunctions"

export const ScenarioKPI:FC<any> = (props):JSX.Element  => {

    const { title,kpiB,kpiC, comparativa,filtered } = props

    return (
        <div className="scenario-kpi__wrapper" >
                <span>{title}{filtered && title === 'Coste (€)'?<span style={{color:'red'}}>**</span>:false}</span>
                <div>
                    {
                        comparativa?
                        <>
                            <div style={{minWidth:90}}>
                                {
                                    isNanParseFloatTreatment(kpiB) > isNanParseFloatTreatment(kpiC)?
                                    <IoMdArrowDropup style={{marginLeft:'0.25rem',color:'green',minWidth:20}} size={16} />
                                    :
                                    isNanParseFloatTreatment(kpiC) > isNanParseFloatTreatment(kpiB)?
                                    <IoMdArrowDropdown style={{marginLeft:'0.25rem',color:'red',minWidth:20}} size={16} />
                                    :
                                    <span style={{marginLeft:'0.25rem',color:'gray'}}>-</span>
                                }
                                
                                <span style={{color: 'var(--lis-dark)'}}>{numberFormatter(isNaN(kpiB) ? 0 : kpiB) }</span>
                                
                            </div>
                            <div style={{minWidth:90}}>
                            {
                                    isNanParseFloatTreatment(kpiB) < isNanParseFloatTreatment(kpiC)?
                                    <IoMdArrowDropup style={{marginLeft:'0.25rem',color:'green',minWidth:20}} size={16} />
                                    :
                                    isNanParseFloatTreatment(kpiC) < isNanParseFloatTreatment(kpiB)?
                                    <IoMdArrowDropdown style={{marginLeft:'0.25rem',color:'red',minWidth:20}} size={16} />
                                    :
                                    <span style={{marginLeft:'0.25rem',color:'gray'}}>-</span>
                                }
                                <span style={ {color: 'var(--lis-alternative)'}}>{numberFormatter(isNaN(kpiC) ? 0 : kpiC) }</span>
                            </div>
                        </>
                        :
                        <>
                            <div>
                                <span style={{color: 'var(--lis-dark)'}}>{numberFormatter(isNaN(kpiB) ? 0 : kpiB) }</span>
                            </div>
                        </>
                    }
                    
                    
                </div>
                
            </div>
    )
}